import React from "react";
import "../../App.css";

export default function Criteria() {
  return (
    <div className="criteria-container">
      <h1 className="criteria">CRITERIA ON ASSESSING STUDENTS WORKS</h1>
      <div className="criteria-info">
        <p>LOTE Victorian Essential Learning Standards (VELS) is used in determining students learning outcomes. Students will be Asses on: listening, speaking,
reading and writing.
        </p>
        <h3>A. Speaking</h3>
        <ul>
              <li>1.  Ask/answer simple questions</li>
              <li>2.	Use variety of words in speaking with others with correct accent and pronunciation</li>
              <li>3.	Explain or discuss a topic orally</li>
              <li>4.	Engage in real or simulated conversations in Filipino with classmates</li>
              <li>5.	Use oral language to justify, compare or describe ideas or events</li>
              <li>6.	Identify and imitate culturally appropriate language and gesture</li>
        </ul>
        <h3>B. Listening</h3>
        <ul>
              <li>1.  Follow spoken instructions</li>
              <li>2.  Comprehend and determine relationship between speakers in conversation</li>
              <li>3.	Participate effectively in discussion in small groups</li>
              <li>4.	Understand information presented in various contexts</li>
              <li>5.	Repeat an idea in different words</li>
        </ul>
        <h3>C. Reading</h3>
        <ul>
              <li>1.  Read passages silently or aloud</li>
              <li>2.  Understand information read in a variety of ways</li>
              <li>3.	Identify main message in a text and use this information in an activity</li>
              <li>4.	Infer using facts and idea read</li>
              <li>5.	Identify different forms of texts</li>
        </ul>
        <h3>D. Writing</h3>
        <ul>
              <li>1.  Imitate and adapt models to create their own simple text</li>
              <li>2.  Record information read or heard</li>
              <li>3.	Write sentences, paragraph on any topics with correct grammar and spelling</li>
              <li>4.	Proofread other works</li>
              <li>5.	Write an idea using variety of words through writing</li>
              <li>6.	Elaborate ideas and information read through writing. Copy words and phrases or fill in a skeleton outline</li>
              <li>7.	Write read or heard into other forms of text</li>
        </ul>
      </div>
    </div>
  );
}
